import { formatMitarbeiterFullName } from '@/filter/mitarbeiter';

export default {
  methods: {
    formatMitarbeiterFullName(value) {
      return formatMitarbeiterFullName(value);
    },
  },
};
